import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

interface StyleProps {
  divider?: boolean;
}

const useStyles = makeStyles((theme) => ({
  row: ({ divider }: StyleProps) => ({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: divider
      ? theme.spacing(2, 2, 2, 0)
      : theme.spacing(1.5, 2, 1.5, 0),
    borderBottom: divider ? `1px solid ${theme.palette.divider}` : 'none',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      padding: theme.spacing(1, 1, 1, 0),
      borderBottom: 'none',
    },
  }),
  narrowRow: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1, 1, 0),
    borderBottom: 'none',
  },
  label: {
    ...theme.typography.subtitle2,
    color: theme.palette.text.secondary,
    minWidth: 200,
    display: 'flex',
    flex: 0,
    alignItems: 'center',
  },
  value: {
    ...theme.typography.body1,
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
  },
  overflow: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'inherit',
  },
}));

interface CardDataRowProps {
  label: React.ReactNode;
  value?: React.ReactNode;
  narrow?: boolean;
  divider?: boolean;
}

export default function CardDataRow({
  label,
  value = null,
  narrow = false,
  divider = false,
}: CardDataRowProps): JSX.Element {
  const classes = useStyles({ divider });

  return (
    <div className={narrow ? classes.narrowRow : classes.row}>
      <div className={classes.label}>
        <div>{label}</div>
      </div>
      <div className={classes.value}>
        <div className={classes.overflow}>{value ?? <>&nbsp;</>}</div>
      </div>
    </div>
  );
}
